import React from 'react'
import { AnimatedIcon } from 'shared/library/atoms/Icon'
import { H4, Text } from 'library/atoms/Typography'
import Button from 'library/atoms/Button'
import useTranslation from 'next-translate/useTranslation'

export interface ModalContentRemoveMembershipProps {
  closeModal: () => void
  continueAddToBasket: () => void
}

const ModalContentRemoveMembership = ({
  continueAddToBasket,
  closeModal
}: ModalContentRemoveMembershipProps) => {
  const { t } = useTranslation('chargeable')

  return (
    <>
      <AnimatedIcon name="exclamation" size={64} autoplay freezeOnLastFrame />
      <H4>{t('remove-membership')}</H4>
      <Text textAlign="center">{t('remove-membership-from-basket')}</Text>
      <Button
        aria-label={t('common:remove-membership')}
        onClick={continueAddToBasket}
      >
        {t('common:continue')}
      </Button>
      <Button
        variant="tertiary"
        onClick={closeModal}
        aria-label={t('common:cancel-remove-membership')}
      >
        {t('common:cancel')}
      </Button>
    </>
  )
}

export default ModalContentRemoveMembership
